import config from 'config/config';
import { PlaceholderImageUrl } from './BundleService';
import moment from 'moment';
import { getMicroContentList } from 'Services/Microexperiences';

import Cookies from 'universal-cookie';

function parseFilterObject(filter) {
    return Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
}


const apiServer = config.experienceApiUrl + '/api/v1';
const productSearchAPI = config.productSearchAPIURL + '/api/v1';


function makeUrl(path) {
    return `${apiServer}${path}`
}

const COOKIE_NAME = 'ac_uhq_token';

export function getToken() {
    const cookies = new Cookies();
    const tokenString = cookies.get(COOKIE_NAME)
    return tokenString;
};

function clearToken() {
    // PASS
}

export async function apiGet(path) {
    const token = getToken();

    return fetch(makeUrl(path), {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        if (response.status === 401) {
            clearToken();
            return {}
        }
        return response.json()
    })


}

export async function apiPost(path, data) {
    const token = getToken();
    return new Promise((resolve, reject) => {
        fetch(makeUrl(path), {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if (response.status === 200) {
                resolve(data);
            } else {
                reject(data)
            }
        })
    })
}

export async function apiPatch(path, data) {
    const token = getToken();
    return new Promise((resolve, reject) => {
        fetch(makeUrl(path), {
            method: 'PATCH',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if (response.status === 200) {
                resolve(data);
            } else {
                reject(data)
            }
        })
    })
}



export async function apiDelete(path, data) {
    const token = getToken();

    return fetch(makeUrl(path), {
        method: 'DELETE',
        headers: {
            Authorization: 'Bearer ' + token,
            'content-type': 'application/json',
        },
        body: JSON.stringify(data)
    }).then(response => {
        if (response.status === 401) {
            clearToken();
            return {}
        }
        return response.json()
    })


}

export async function getBundleList(filter) {
    const path = '/bundles';

    return await apiGet(path)
        .then((response) => {
            const data = response.data || [];
            return data?.filter(d => !d.deletedDate) || [];
        })
        .catch((err) => {
            console.error('getBundleList : FAILED : ', err);
            throw new Error('getBundleList : FAILED : ' + JSON.stringify(err));
        });
}

export async function archiveBundle(bundle) {
    bundle.deletedDate = moment().toISOString();

    return await apiPatch('/bundles/' + bundle.id, bundle)
        .then((data) => {
            return data || {};
        })
        .catch((err) => {
            console.error('archiveBundle : FAILED : ', err);
            throw new Error('archiveBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function saveNewBundle(bundle) {
    const path = `/bundles`
    const payload = { ...bundle };
    console.log({ payload })

    return await apiPost(path, payload)
        .then((response) => {
            return response?.data || {};
        })
        .catch((err) => {
            console.error('saveNewBundle : FAILED : ', err);
            throw new Error('saveNewBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function getBundleById(bundleId) {
    const path = `/bundles/` + bundleId;

    return await apiGet(path)
        .then((response) => {
            return response.data || {};
        })
        .catch((err) => {
            console.error('getBundleById : FAILED : ', err);
            throw new Error('getBundleById : FAILED : ' + JSON.stringify(err));
        });
}

export async function fetchProductList(filter) {
    const query = parseFilterObject(filter || {});

    const url = `${productSearchAPI}/products/search-collection?query=${query}&projections=location`;
    return await fetch(url)
        .then(async response => {
            const data = await response.json();
            return data?.data || [];
        }
        )
        .catch(error => {
            console.error('Error fetching products list ')
            return [];
        });
}

export async function fetchMicroexperienceList(filter) {

    return await getMicroContentList()
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('fetchMicroexperienceList : FAILED : ', err);
            throw new Error('fetchMicroexperienceList : FAILED : ' + JSON.stringify(err));
        });
}

export async function removeCardFromBundle(bundle, card) {
    const path = `/bundles/` + bundle.id;
    const cards = bundle.cards;
    let newCards = [...cards];
    const itemIndex = newCards.findIndex(b => b.cardId === card.cardId && b.variation === card.variation);
    newCards.splice(itemIndex, 1);
    // const newCards = bundle.cards?.filter(b => (b.cardId !== card.cardId));

    const payload = { ...bundle, cards: [...newCards] };
    return await apiPatch(path, payload)
        .then((data) => {
            return data || {};
        })
        .catch((err) => {
            console.error('removeCardFromBundle : FAILED : ', err);
            throw new Error('removeCardFromBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function addCardToBundle(bundle, card) {
    const path = `/bundles/` + bundle.id;
    const cards = bundle.cards || [];
    const newCard = { ...card };

    let lastSequenceNumber = 0;

    if (cards.length) { lastSequenceNumber = cards.slice().sort((a, b) => a.sequenceNumber < b.sequenceNumber).slice(-1)[0].sequenceNumber }
    newCard.sequenceNumber = lastSequenceNumber + 1;

    const payload = { ...bundle, cards: [...cards, newCard] };

    return await apiPatch(path, payload)
        .then((data) => {
            return data || {};
        })
        .catch((err) => {
            console.error('addCardToBundle : FAILED : ', err);
            throw new Error('addCardToBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function updateCardInBundle(bundle, card) {
    const path = `/bundles/` + bundle.id;

    const newCards = bundle.cards.filter(c => c.cardId !== card.cardId);
    newCards.push(card);


    const payload = { ...bundle, cards: newCards };

    return await apiPatch(path, payload)
        .then((data) => {
            return data || {};
        })
        .catch((err) => {
            console.error('updateCardInBundle : FAILED : ', err);
            throw new Error('updateCardInBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function saveBundle(bundle) {
    const path = `/bundles/` + bundle.id;
    const payload = { ...bundle };

    return await apiPatch(path, payload)
        .then((response) => {
            return response?.data || {};
        })
        .catch((err) => {
            console.error('saveBundle : FAILED : ', err);
            throw new Error('saveBundle : FAILED : ' + JSON.stringify(err));
        });
}

export async function getProductById(productId) {
    const url = `${productSearchAPI}/products?id=${productId}`;
    const response = await fetch(url);
    const productData = await response.json();
    return productData?.data?.[0]?.data || {};
}


export function mapMicroexperienceToCard(microexperience) {

    const newCard = {
        cardId: microexperience.id,
        cardType: 'MICROEXPERIENCE',
        cardName: microexperience.name,
        cardData: microexperience,
        cardImage: {
            thumbnailUrl: microexperience.experienceImage,
            heroUrl: microexperience.experienceImage,
        },
        subscriptionMap: [
            {
                subscriptionTierCode: 'FREE',
                isAvailable: true,
                discount: 0,
            },
            {
                subscriptionTierCode: 'STANDARD',
                isAvailable: true,
                discount: 0,
            },
            {
                subscriptionTierCode: 'PREMIUM',
                isAvailable: true,
                discount: 0,
            },
        ],
    };

    return newCard;
}


export function mapProductToCard(product) {
    const medias = product?.presentation?.medias || [];
    const thumbnailUrl = medias.find(m => m.type === 'image' && m.section === 'thumbnail')?.url || PlaceholderImageUrl;
    const heroUrl = medias.find(m => m.type === 'image' && m.section === 'hero')?.url || PlaceholderImageUrl;

    const newCard = {
        cardId: product.id,
        cardType: 'PRODUCT',
        cardName: product.name,
        cardData: product,
        cardImage: {
            thumbnailUrl: thumbnailUrl,
            heroUrl: heroUrl,
        },
        subscriptionMap: [
            {
                subscriptionTierCode: 'FREE',
                isAvailable: true,
                discount: 0,
            },
            {
                subscriptionTierCode: 'STANDARD',
                isAvailable: true,
                discount: 0,
            },
            {
                subscriptionTierCode: 'PREMIUM',
                isAvailable: true,
                discount: 0,
            },
        ],
    };

    return newCard;
}

export function mapProductToHero(product) {
    const medias = product?.presentation?.medias || [];
    const thumbnailUrl = medias.find(m => m.type === 'image' && m.section === 'thumbnail')?.url || PlaceholderImageUrl;
    const heroUrl = medias.find(m => m.type === 'image' && m.section === 'hero')?.url || PlaceholderImageUrl;

    const newHero = {
        productId: product.id,
        name: product.name,
        productData: product,
        medias: {
            thumbnailUrl: thumbnailUrl,
            heroUrl: heroUrl,
        },
    };

    return newHero;
}